import { render, staticRenderFns } from "./Shareholders.vue?vue&type=template&id=221a2f0a&"
import script from "./Shareholders.vue?vue&type=script&lang=js&"
export * from "./Shareholders.vue?vue&type=script&lang=js&"
import style0 from "./Shareholders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports